import { camelCase } from 'lodash';
import { useMemo } from 'react';
import {
  FilterableField,
  filterableFieldType,
} from 'components/organisms/tasks/fields';
import { useProjectCustomFields } from './use-project-fields';

export const useProjectCustomFieldsAsFilterableFields = (): {
  loading: boolean;
  fields: FilterableField[];
} => {
  const { data: projectCustomFields, isLoading: isProjectCustomFieldsLoading } =
    useProjectCustomFields();

  return useMemo(
    () => ({
      loading: isProjectCustomFieldsLoading,
      fields: (
        projectCustomFields.map((field) => ({
          ...field,
          fieldName: camelCase(field.fieldName),
          type: filterableFieldType(field),
        })) as FilterableField[]
      ).filter((field) => field.isEnabled),
    }),
    [isProjectCustomFieldsLoading, projectCustomFields],
  );
};
